import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type WarehouseKPI, type WarehouseIntelligence } from '../../api/warehouseexec';

export function WarehouseKPIPage() {
  const [kpi, setKpi] = useState<WarehouseKPI | null>(null);
  const [intel, setIntel] = useState<WarehouseIntelligence | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void Promise.all([warehouseexecApi.kpis(), warehouseexecApi.intelligence()])
      .then(([k, i]) => { setKpi(k); setIntel(i); })
      .catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/warehouse" className="text-sm text-slate-600 hover:underline">← Warehouse hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Warehouse KPIs</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      {kpi && (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {[
            { label: 'Picks completed', value: kpi.picks_completed },
            { label: 'Packs completed', value: kpi.packs_completed },
            { label: 'Avg pick time (min)', value: kpi.avg_pick_time_min.toFixed(1) },
            { label: 'Packing accuracy', value: `${(kpi.packing_accuracy * 100).toFixed(1)}%` },
          ].map((s) => (
            <div key={s.label} className="rounded-xl border p-4">
              <p className="text-sm text-slate-500">{s.label}</p>
              <p className="mt-1 text-xl font-semibold">{s.value}</p>
            </div>
          ))}
        </div>
      )}
      {intel && (
        <div className="mt-8 rounded-xl border p-4">
          <h2 className="font-semibold">AI intelligence</h2>
          <ul className="mt-2 space-y-1 text-sm text-slate-700">
            <li>Congestion level: {intel.congestion_level.toFixed(2)}</li>
            <li>Recommended workers: {intel.recommended_workers}</li>
            <li>Pick time prediction: {intel.pick_time_prediction_min.toFixed(1)} min</li>
            <li>Pack time prediction: {intel.pack_time_prediction_min.toFixed(1)} min</li>
            {intel.pick_route_hint && <li>Route hint: {intel.pick_route_hint}</li>}
          </ul>
        </div>
      )}
    </div>
  );
}
